var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vip_card_nav_inner" },
    [
      _vm.goodsList && _vm.goodsList.length > 0
        ? [
            _c(
              "div",
              { staticClass: "tabs" },
              [
                _c(
                  "el-tabs",
                  {
                    on: { "tab-click": _vm.tabChange },
                    model: {
                      value: _vm.activeTab,
                      callback: function ($$v) {
                        _vm.activeTab = $$v
                      },
                      expression: "activeTab",
                    },
                  },
                  _vm._l(_vm.tabList, function (item) {
                    return _c("el-tab-pane", {
                      key: item.id,
                      attrs: { label: item.name, name: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm.value.config.show_type === 2
              ? _c(
                  "div",
                  { staticClass: "box2" },
                  _vm._l(_vm.goodsList, function (item, index) {
                    return _c("div", { key: index, staticClass: "item" }, [
                      _c("div", {
                        staticClass: "pic",
                        style: {
                          backgroundImage: "url(" + item.goods_thumb + ")",
                        },
                      }),
                      _c("div", { staticClass: "right" }, [
                        _c("div", { staticClass: "info" }, [
                          _c("div", { staticClass: "name u-line-2" }, [
                            _vm._v(_vm._s(item.goods_name)),
                          ]),
                          _c("div", { staticClass: "inventory" }, [
                            _vm._v("库存: 900"),
                          ]),
                        ]),
                        _c("div", { staticClass: "price" }, [
                          _c("span", { staticClass: "num" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("moneyFormat")(item.shop_price)) +
                                " "
                            ),
                          ]),
                          _vm._v(" 点 "),
                        ]),
                      ]),
                    ])
                  }),
                  0
                )
              : _c(
                  "div",
                  { staticClass: "box" },
                  _vm._l(_vm.goodsList, function (item, index) {
                    return _c("div", { key: index, staticClass: "item" }, [
                      _c("div", {
                        staticClass: "pic",
                        style: {
                          backgroundImage: "url(" + item.goods_thumb + ")",
                        },
                      }),
                      _c("div", { staticClass: "name u-line-2" }, [
                        _vm._v(_vm._s(item.goods_name)),
                      ]),
                      _c("div", { staticClass: "price" }, [
                        _c("span", { staticClass: "num" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("moneyFormat")(item.shop_price)) +
                              " "
                          ),
                        ]),
                        _vm._v(" 点 "),
                      ]),
                    ])
                  }),
                  0
                ),
          ]
        : _c("empty", { attrs: { value: _vm.value } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }